const salary = [
	{
		path: '/salary-source-types/list',
		name: 'jobs-salary-source-types-list',
		component: () => import(/* webpackChunkName: "SalaryList" */ '@/views/jobs/salary-source-types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,salary',
		},
	},
	{
		path: '/salary-submissions/list',
		name: 'jobs-salary-submissions-list',
		component: () => import(/* webpackChunkName: "SubmissionsList" */ '@/views/jobs/salary-submissions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,salary',
		},
	},
	{
		path: '/salary-submissions/create',
		name: 'jobs-salary-submissions-create',
		component: () => import(/* webpackChunkName: "SubmissionsCreate" */ '@/views/jobs/salary-submissions/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,salary',
		},
	},
	{
		path: '/salary-submissions/edit/:id',
		name: 'jobs-salary-submissions-edit',
		component: () => import(/* webpackChunkName: "SubmissionsCreate" */ '@/views/jobs/salary-submissions/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,salary',
		},
	},
]

export default salary
